'use client';
/** @jsxImportSource @emotion/react */

import * as React from 'react';
import { type SVGProps } from 'react';
const Checkmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height={24}
    viewBox="0 0 24 24"
    width={24}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.075 18.864c-.29 0-.567-.114-.772-.319l-5.978-5.957a1.096 1.096 0 1 1 1.543-1.555l5.088 5.077L18.97 5.458a1.092 1.092 0 1 1 1.745 1.315l-8.773 11.656a1.091 1.091 0 0 1-.79.435h-.077Z"
      fill="currentColor"
    />
  </svg>
);
export default Checkmark;
